module.exports = __webpack_public_path__ + "static/Sell on Solv-0880751fa1ad854f0de9f07ecfb04aab.png";